import { FC, useState } from 'react';
import { Container, Cover, Thumbnail, ThumbsContainer } from './SpotlightCarousel.styles';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

interface SpotlightCarouselProps {
	images: string[];
}

const SpotlightCarousel: FC<SpotlightCarouselProps> = ({ images }) => {
	const [spotlightImage, setSpotlightImage] = useState(images[0]);

	const responsiveCarousel = {
		desktop: {
			breakpoint: { max: 3000, min: 1200 },
			items: 4,
		},
		mobile: {
			breakpoint: { max: 1199, min: 0 },
			items: 1,
		},
	};

	return (
		<Container>
			<Cover src={spotlightImage} />
			<Carousel responsive={responsiveCarousel} infinite autoPlay autoPlaySpeed={3000}>
				{images.map((image, index) => (
					<ThumbsContainer key={index} role='button' onClick={() => setSpotlightImage(image)}>
						<Thumbnail src={image} alt='imagem carrossel' />
					</ThumbsContainer>
				))}
			</Carousel>
		</Container>
	);
};

export default SpotlightCarousel;
